import { useEffect, useCallback, useState } from 'react';
import { API_CONFIG } from '../config/apiConfig';

const getHeaders = () => ({
    'Content-Type': 'application/json',
    'X-Admin-Token': localStorage.getItem('cinestream_token') || ''
});

/**
 * Hook pour gérer les achievements
 * VERSION ULTRA FIXÉE - Attend que userId soit défini
 */
const useAchievements = (userId) => {
    const [notifications, setNotifications] = useState([]);

    // Vérifier les achievements
    const checkAchievements = useCallback(async () => {
        // ✅ NE RIEN FAIRE SI userId est undefined/null
        if (!userId) {
            return;
        }

        try {
            const response = await fetch(`${API_CONFIG.NEW_API_BASE}/achievements/check`, {
                method: 'POST',
                headers: getHeaders(),
                body: JSON.stringify({ userId }),
            });

            if (!response.ok) {
                throw new Error('HTTP error ' + response.status);
            }

            const data = await response.json();

            if (data.success && data.newlyUnlocked && data.newlyUnlocked.length > 0) {
                // Ajouter les nouvelles notifications avec délai
                data.newlyUnlocked.forEach((achievement, index) => {
                    setTimeout(() => {
                        setNotifications(prev => [...prev, {
                            id: `${achievement.id}-${Date.now()}-${index}`,
                            ...achievement
                        }]);
                    }, index * 500);
                });
            }
        } catch (error) {
            console.error('❌ Erreur vérification achievements:', error);
        }
    }, [userId]);

    // ✅ Vérifier UNIQUEMENT quand userId change et est défini
    useEffect(() => {
        if (!userId) {
            return;
        }

        // Premier check immédiat
        checkAchievements().then();

        // Puis toutes les 30 secondes
        const interval = setInterval(checkAchievements, 30000);

        return () => {
            clearInterval(interval);
        };
    }, [userId, checkAchievements]);

    // Retirer une notification
    const removeNotification = useCallback((id) => {
        setNotifications(prev => prev.filter(n => n.id !== id));
    }, []);

    return {
        notifications,
        removeNotification,
        checkAchievements
    };
};

export default useAchievements;